import { useAuth } from "../../Contexts/AuthContext";
import styles from "./Admin.module.scss";
import { useNavigate } from "react-router-dom";

export default function Admin() {
  const {login } = useAuth();
  const navigate = useNavigate()

  const LoginGoogle = async () => {
    await login();
  };

  const Voltar = () => navigate('/')

  return (
    <div className={styles.LoginContainer}>
      <div>
        <h1>Acesse com o Google</h1>
      </div>
      <div>
        <button onClick={LoginGoogle}>Login</button>
        <button onClick={Voltar}>Voltar</button>
      </div>
    </div>
  );
}
